export function chooseAtividade(atividade) {
  return {
    type: '@questionario/ATIVIDADE_CHOOSED',
    payload: { atividade },
  };
}
